<template>
  <div class="games transfer__wrapper">
    <form-layout
      :main-title="$t('superPass.purchase.title')"
      :small-title="true"
      :title="$t('superPass.pass.title')"
      @back="goBack"
      @submit="changeModal"
    >
      <div class="transfer__form">
        <Input v-model="search" :placeholder="$t('superPass.pass.placeholder')" icon="/base/search.svg" type="text" />
        <div class="transfer__form-games-list">
          <Loader v-if="isLoading" />
          <template v-else-if="passesList.length">
            <div v-for="pass in passesList" :key="pass.id" @click="selectPass(pass)">
              <PassCard :pass="pass" :current="currentPass" />
            </div>
          </template>
          <EmptyListInfo v-else>
            <template #text>
              <span v-if="search">
                {{ $t('superPass.empty.passSearch') }}
              </span>
              <span v-else>
                {{ $t('superPass.empty.pass') }}
              </span>
            </template>
          </EmptyListInfo>
        </div>
        <!--        <Input class="transfer__form-search-input" v-if="isShowSearch" type="text" v-model="search" :light="true" />-->
        <!--        <div class="transfer__form-footer">-->
        <!--          <Button-->
        <!--            class="transfer__form-search-btn"-->
        <!--            left-icon="/base/search.svg"-->
        <!--            @click="isShowSearch = !isShowSearch"-->
        <!--          />-->
        <!--          <Button class="transfer__form-btn" :disabled="!currentPass.name" @click="changeModal">-->
        <!--            {{ $t('actions.continue') }}-->
        <!--          </Button>-->
        <!--        </div>-->
      </div>
    </form-layout>
  </div>
</template>

<script>
import './superPassPasses.scss'

import Loader from '@/components/LoaderBar/LoaderBar'
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'
import PassCard from '@/components/PassCard/PassCard.vue'
import Input from '@/components/Base/Input/Input.vue'
import EmptyListInfo from '@/components/EmptyListInfo/EmptyListInfo.vue'
import { openChat } from '@/utils/chat'
import { normalizeAmount } from '@/utils/formatting'

export default {
  name: 'SuperPassPasses',
  components: {
    EmptyListInfo,
    Input,
    PassCard,
    FormLayout,
    Loader
  },
  props: {
    game: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isLoading: true,
      currentPass: {},
      isShowSearch: false,
      search: '',
      passes: []
    }
  },
  computed: {
    passesList() {
      const passes = this.passes.filter(pass => pass.enabled).sort((a, b) => b.orders - a.orders)

      if (this.search) {
        return passes.filter(pass => pass.name.toLowerCase().includes(this.search.toLowerCase()))
      } else {
        return passes
      }
    }
  },
  methods: {
    openChat,
    changeModal() {
      if (!this.currentPass.name) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('superPass.errors.emptyPass'),
          type: 'error'
        })

        return
      }

      this.$store.commit('setScipGamepass', false)

      this.$analytics.send('purch_super_2_pass', {})

      this.$emit('changeModal', {
        modal: 'TransferCharacters',
        pass: this.currentPass
      })
    },
    goBack() {
      this.$emit('changeModal', {
        modal: 'SuperPassGames',
        data: []
      })
    },
    selectPass(pass) {
      this.currentPass = pass
    },
    async getPasses() {
      const requestHeaders = new Headers({
        Authorization: `Bearer ${this.$cookies.get('access_token')}`
      })

      const requestParams = {
        method: 'GET',
        headers: requestHeaders
      }

      try {
        const response = await fetch(`https://transfer.backend-pier.com/sp_new?game_ids=${this.game.id}`, requestParams)
        const data = await response.json()

        if (data.status) {
          this.passes = data.superpasses
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    updatedPassesWithDiscount(passes) {
      if (!passes) return []
      const sale = 30

      return passes?.map(pass => ({
        ...pass,
        sale,
        oldRubleAmount: normalizeAmount(pass.amount.rub * (1 + sale / 100))
      }))
    }
  },
  mounted() {
    this.getPasses()
  }
}
</script>
